// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__3bK1J","selects":"Documents_selects__3z4Uc"};